import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../config.service";
import { StaffKpiData } from "./types/kpi";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class KpiReportService {


    constructor(
        private http: HttpClient,
        private config: ConfigService
    )
     {

     }

     /**
      * Returns the KPI report for a specific staff member
      * @param staffId the staff member to get the report for
      * @returns 
      */
     getKpiReportForStaff(staffId: number, yerMode: boolean = false) {
        return this.http.get<StaffKpiData>(`${this.config.dataApiUrl}/kpi/report/${staffId}?yerMode=${yerMode}`)
     }

     /**
      * Returns the KPI report for all staff members in the current user's permission chain, including the
      * logged in user
      * @returns 
      */
     getKpiReport() {
        return this.http.get<StaffKpiData[]>(`${this.config.dataApiUrl}/kpi/report`)
     }

     getKpiStatus(staffId: number) {
        return this.http.get<{hasStandardKpis: boolean}>(`${this.config.dataApiUrl}/kpi/status/${staffId}`)
     }

  getOverallScore(staffId: number, yerMode: boolean = false) {
    return this.http.get<{ baseScore: number; skillScore: number; totalScore: number; skillWeight: number }>(
      `${this.config.dataApiUrl}/kpi/report/${staffId}/overall-score?yerMode=${yerMode}`
    )
  }


     emptyStaffKpiData() { 
        return {
            staffId: 0,
            name: '',
            title: '',
            jobDescription: '',
            kpiTemplate: '',
            kpis: [],
            kpiScore: null,
            skillScore: null,
            totalScore: null
        }
     }

     getHrExport() {
        return this.http.get(`${this.config.dataApiUrl}/kpi/report/hr-export`, { responseType: 'blob' })
     }

}